export enum CognitoChallenge {
  SMS = "SMS_MFA",
  NEW_PASSWORD = "NEW_PASSWORD_REQUIRED",
}
